import { KeyValuePipe, NgForOf, NgIf } from "@angular/common";
import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, FormsModule, ReactiveFormsModule, Validators } from "@angular/forms";
import { Router, RouterLink } from "@angular/router";
import * as _ from 'lodash';
import { DialogModule } from "primeng/dialog";
import { DropdownModule } from "primeng/dropdown";
import { FileUploadModule } from "primeng/fileupload";
import { InputTextModule } from "primeng/inputtext";
import { InputTextareaModule } from "primeng/inputtextarea";
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { RadioButtonModule } from "primeng/radiobutton";
import { TooltipModule } from "primeng/tooltip";
import { environment } from '../../environments/environment';
import { ECollection } from '../enums/ECollection';
import { EOrderStatus } from "../enums/EOrderStatus";
import { EProductGroupType } from '../enums/EProductGroupType';
import { IProducts_P } from "../interfaces/IProducts";
import { AddOrderService } from "../service/add-order.service";
import { AuthService } from "../service/auth.service";
import { DataProviderService } from '../service/data-provider.service';
import { EventS } from '../service/event.s';
import { NotificationService } from "../service/notification.service";
import { OrderCheckoutService } from "../service/order-checkout.service";
import { OrderFileUploadService } from "../service/order-file-upload.service";
import { TaxesService } from '../service/taxes.service';
import { UserService } from "../service/user.service";

@Component({
    selector: 'app-product-order',
    standalone: true,
    imports: [ InputTextModule, ReactiveFormsModule, TooltipModule, DropdownModule, RadioButtonModule, NgIf, InputTextareaModule, FormsModule, RouterLink, FileUploadModule, NgForOf, DialogModule, ProgressSpinnerModule, KeyValuePipe ],
    templateUrl: './product-order.component.html',
    styleUrl: './product-order.component.scss'
})
export class ProductOrderComponent implements OnInit, OnChanges {
    loading: boolean = false;
    checkoutForm: FormGroup;
    allOrdersRaw: any;
    allOrdersFlat: Order[] = [];
    filterGstProducts: Order[] = [];
    filterNonGstProducts: Order[] = [];
    currentProductOrdered: IProducts_P = <any>{};

    shipping: number = 0;
    shippingWithGst: number = 0;

    transportCharge: number = 0;
    transportWithGstCharge: number = 0;

    totalOrderAmount: number = 0;
    totalGstAmount: number = 0;
    totalGstCharge: number = 0;

    fullAddressObject: any | undefined;
    totalOrders: number = 0;
    selectedDeliveryType: any;

    visible: boolean = false;
    uploadedFiles: any[] = [];
    // currentProductGroup: string = '';
    currentProductGroupCategory: string = '';
    progress: { [key: string]: number } = {};
    intervals: any = {};

    @Output() count = new EventEmitter<number>();
    @Input() productGroupId: string = '';
    @Input() productName: string = '';
    @ViewChild('fileUploader') fileUploader: any;

    quantity: qty[] = [
        { name: '1000', code: '1000' },
        { name: '2000', code: '2000' },
        { name: '3000', code: '3000' },
        { name: '4000', code: '4000' },
        { name: '5000', code: '5000' },
        { name: '6000', code: '6000' },
        { name: '7000', code: '7000' },
        { name: '8000', code: '8000' },
        { name: '9000', code: '9000' },
        { name: '10000', code: '10000' },
        { name: '11000', code: '11000' },
        { name: '12000', code: '12000' },
        { name: '13000', code: '13000' },
        { name: '14000', code: '14000' },
        { name: '15000', code: '15000' },
        { name: '16000', code: '16000' },
        { name: '17000', code: '17000' },
        { name: '18000', code: '18000' },
        { name: '19000', code: '19000' },
        { name: '20000', code: '20000' },
        { name: '21000', code: '21000' },
        { name: '22000', code: '22000' },
        { name: '23000', code: '23000' },
        { name: '24000', code: '24000' },
        { name: '25000', code: '25000' },
        { name: '26000', code: '26000' },
        { name: '27000', code: '27000' },
        { name: '28000', code: '28000' },
        { name: '29000', code: '29000' },
        { name: '30000', code: '30000' },
        { name: '31000', code: '31000' },
        { name: '32000', code: '32000' },
        { name: '33000', code: '33000' },
        { name: '34000', code: '34000' },
        { name: '35000', code: '35000' },
        { name: '36000', code: '36000' },
        { name: '37000', code: '37000' },
        { name: '38000', code: '38000' },
        { name: '39000', code: '39000' },
        { name: '40000', code: '40000' },
        { name: '41000', code: '41000' },
        { name: '42000', code: '42000' },
        { name: '43000', code: '43000' },
        { name: '44000', code: '44000' },
        { name: '45000', code: '45000' },
        { name: '46000', code: '46000' },
        { name: '47000', code: '47000' },
        { name: '48000', code: '48000' },
        { name: '49000', code: '49000' },
        { name: '50000', code: '50000' }
    ];

    smallQuantity: qty[] = [
        { name: '500', code: '500' },
        { name: '1000', code: '1000' },
        { name: '1500', code: '1500' },
        { name: '2000', code: '2000' },
        { name: '2500', code: '2500' },
        { name: '3000', code: '3000' },
        { name: '3500', code: '3500' },
        { name: '4000', code: '4000' },
        { name: '4500', code: '4500' },
        { name: '5000', code: '5000' },
        { name: '5500', code: '5500' },
        { name: '6000', code: '6000' },
        { name: '6500', code: '6500' },
        { name: '7000', code: '7000' },
        { name: '7500', code: '7500' },
        { name: '8000', code: '8000' },
        { name: '8500', code: '8500' },
        { name: '9000', code: '9000' },
        { name: '9500', code: '9500' },
        { name: '10000', code: '10000' },
        { name: '10500', code: '10500' },
        { name: '11000', code: '11000' },
        { name: '11500', code: '11500' },
        { name: '12000', code: '12000' },
        { name: '12500', code: '12500' },
        { name: '13000', code: '13000' },
        { name: '13500', code: '13500' },
        { name: '14000', code: '14000' },
        { name: '14500', code: '14500' },
        { name: '15000', code: '15000' },
        { name: '15500', code: '15500' },
        { name: '16000', code: '16000' },
        { name: '16500', code: '16500' },
        { name: '17000', code: '17000' },
        { name: '17500', code: '17500' },
        { name: '18000', code: '18000' },
        { name: '18500', code: '18500' },
        { name: '19000', code: '19000' },
        { name: '19500', code: '19500' },
        { name: '20000', code: '20000' },
        { name: '20500', code: '20500' },
        { name: '21000', code: '21000' },
        { name: '21500', code: '21500' },
        { name: '22000', code: '22000' },
        { name: '22500', code: '22500' },
        { name: '23000', code: '23000' },
        { name: '23500', code: '23500' },
        { name: '24000', code: '24000' },
        { name: '24500', code: '24500' },
        { name: '25000', code: '25000' }
    ];

    extraOptions: qty[] = [
        { name: '0', code: '0' },
        { name: '1', code: '1' },
        { name: '2', code: '2' },
        { name: '3', code: '3' },
        { name: '4', code: '4' },
        { name: '5', code: '5' },
        { name: '6', code: '6' },
        { name: '7', code: '7' },
        { name: '8', code: '8' },
        { name: '9', code: '9' },
        { name: '10', code: '10' },
        { name: '11', code: '11' },
        { name: '12', code: '12' },
        { name: '13', code: '13' },
        { name: '14', code: '14' },
        { name: '15', code: '15' },
        { name: '16', code: '16' },
        { name: '17', code: '17' },
        { name: '18', code: '18' },
        { name: '19', code: '19' },
        { name: '20', code: '20' },
        { name: '21', code: '21' },
        { name: '22', code: '22' },
        { name: '23', code: '23' },
        { name: '24', code: '24' },
        { name: '25', code: '25' },
        { name: '26', code: '26' },
        { name: '27', code: '27' },
        { name: '28', code: '28' },
        { name: '29', code: '29' },
        { name: '30', code: '30' },
        { name: '31', code: '31' },
        { name: '32', code: '32' },
        { name: '33', code: '33' },
        { name: '34', code: '34' },
        { name: '35', code: '35' },
        { name: '36', code: '36' },
        { name: '37', code: '37' },
        { name: '38', code: '38' },
        { name: '39', code: '39' },
        { name: '40', code: '40' },
        { name: '41', code: '41' },
        { name: '42', code: '42' },
        { name: '43', code: '43' },
        { name: '44', code: '44' },
        { name: '45', code: '45' },
        { name: '46', code: '46' },
        { name: '47', code: '47' },
        { name: '48', code: '48' },
        { name: '49', code: '49' },
        { name: '50', code: '50' }
    ];

    delivery: deliver[] = [
        { name: 'Courier', code: 'Courier' },
        { name: 'Transport', code: 'Transport' },
        { name: 'Collect From Office', code: 'Collect_From_Office' }
    ];
    Number = Number;

    EProductGroupType = EProductGroupType;

    tax: number = 0;

    constructor(
        private fb: FormBuilder,
        private addOrderService: AddOrderService,
        public authService: AuthService,
        private orderCheckoutService: OrderCheckoutService,
        private userService: UserService,
        private eventCenterS: EventS,
        private ns: NotificationService,
        private taxesService: TaxesService,
        private router: Router,
        private dataProvider: DataProviderService,
        private orderFileUploadService: OrderFileUploadService,
    ) {
        this.checkoutForm = this.fb.group({
            selectedDelivery: [ '', Validators.required ],
            // parcelNumber: [''],
            parcelAddress: [ '' ],
            parcelNumber: [ '', Validators.min(0) ],
            ingredient: [ 'Delivery' ],
            text: [ '' ],
            defaultAddress: [ '', Validators.required ],
            jobName: [ '' ],
            message: [ '' ]
        });
    }


    async ngOnInit() {
        this.eventCenterS.loadAddToCardProducts.subscribe(async (data: boolean) => {
            if (data) await this.getOrders();
        });


        await this.getOrders();
        // this.totalOrderAmount = this.allOrdersFlat.reduce((acc: number, order: Order) => {
        //     return acc + Number(order.totalPrice);
        // }, 0);
        this.fullAddressObject = await this.getFullAddress();
        this.checkoutForm.patchValue({
            defaultAddress: this.fullAddressObject.fullAddress
        });
    }

    async ngOnChanges(changes: SimpleChanges) {
        if (changes['productGroupId']?.previousValue !== changes['productGroupId']?.currentValue) {
            await this.getOrders();
            // console.log(changes['productGroupId']);
        }
        if (changes['productName']?.previousValue !== changes['productName']?.currentValue && !changes['productName'].previousValue) {
            this.uploadedFiles = [];
            this.fileUploader?.clear();
        }
    }

    //File Upload Section
    // async onUpload(event: any) {
    //     // this.loading = true;
    //     for (let file of event.files) {
    //         if (this.isCdrFile(file)) {
    //             this.uploadedFiles.push(file);
    //             this.ns.showSuccess("File upload successfully.");
    //             // await this.onSubmit();
    //             // this.loading = false;
    //         } else {
    //             this.ns.showError(`Invalid File ${file.name} is not a .cdr file`);
    //             // this.loading = false;
    //         }
    //     }
    // }

    async onUpload(event: any) {
        for (let file of event.files) {
            this.uploadedFiles.push(file);
            if (!this.isCdrFile(file)) {
                this.ns.showError(`Invalid File: ${ file.name } is not a .cdr file`);
                continue;
            }

            this.progress[file.name] = 0;

            const interval = setInterval(() => {
                if (this.progress[file.name] < 100) {
                    this.progress[file.name] += 1;
                } else {
                    clearInterval(interval);
                    delete this.intervals[file.name];
                    this.ns.showSuccess("File upload successfully.");

                    setTimeout(() => {
                        delete this.progress[file.name];
                    }, 500); // waits before removing so user can see 100%
                }
            }, 25);
            this.intervals[file.name] = interval;
        }
    }

    showDialog() {
        this.visible = true;
    }

    isCdrFile(file: any): boolean {
        return file.name.toLowerCase().endsWith('.cdr');
    }

    async fileUpload(files: File[]) {
        if (files.length) {
            const formData = new FormData();
            formData.append('bucketName', environment.BUCKET_NAME);
            files.forEach((file: File) => formData.append('files', file));
            try {
                return await this.orderFileUploadService.fileUpload(formData);
            } catch (e: any) {
                this.ns.showError(`Invalid File`);
            }
        }
    }

    async getOrders() {
        let groupId = this.dataProvider.getDataForAddOrder().productGroupId;
        // console.log('groupID', groupId)

        this.allOrdersRaw = await this.addOrderService.query({
            find: {
                user_objid: this.authService.gUser?._id,
                active: true,
                productGroup_objid: groupId
            },
            deep: [
                {
                    s_key: "product_objid",
                    t_instance: environment.INS,
                    t_db: environment.DB,
                    t_col: ECollection.MP_PRODUCTS,
                    t_key: "_id",
                    select: {
                        mpp_productName_str: 1,
                        mpp_courierCharges_num: 1,
                        mpp_transportCharge_num: 1,
                        mpp_productGroup_objid: 1,
                        mpp_IsGstProduct_bl: 1,
                        // mpp_productPrice_num: 1,
                        mpp_order_num: 1,
                        mpp_halfBladePerPrice_num: 1,
                        mpp_perforatedPerPrice_num: 1,
                        mpp_creassingPerPrice_num: 1,
                        mpp_diePerPrice_num: 1,
                        mpp_punchingPerPrice_num: 1,
                        mpp_foldingPerPrice_num: 1,
                        mpp_foil_golden_price_num: 1,
                        mpp_foil_silver_price_num: 1,
                        mpp_spot_uv_single_price_num: 1,
                        mpp_spot_uv_both_price_num: 1,
                    },
                    deep: [
                        {
                            s_key: "mpp_productGroup_objid",
                            t_instance: environment.INS,
                            t_db: environment.DB,
                            t_col: ECollection.MP_PRODUCT_GROUPS,
                            t_key: "_id",
                            select: {
                                mpg_tax_objid: 1,
                                mpg_courierCharges_num: 1,
                                mpg_transportCharges_num: 1,
                                // mpg_transportChargesWithGst_num: 1,
                                // mpg_courierChargesWithGst_num: 1,
                                mpg_hsnCode_num: 1,
                                mpg_productGroupCategory_str: 1,
                            }
                        }
                    ],
                }
            ],
        });
        this.currentProductOrdered = this.allOrdersRaw[0]?.product_objid;
        this.allOrdersFlat = this.allOrdersRaw.map((order: any) => {
            return {
                _id: order._id,
                productName: order.product_objid?.mpp_productName_str,
                productGroup: order.productGroup,
                productGroupName: order.productGroupName, // ✅ included explicitly
                productGroupCategory: order.productGroupCategory, // ✅ included explicitly
                productsGroup_objid: order.productGroup_objid, // ✅ included explicitly
                user_objid: order.user_objid,
                price: order.price,
                jobName: order.jobName,
                quantity: order.quantity,
                halfBlade: order.halfBlade,
                crizzing: order.crizzing,
                perforate: order.perforate,
                dieCharge: order.dieCharge,
                printing_side: order.printing_side,
                squareAndRegular: order.squareAndRegular,
                punchingCharge: order.punchingCharge,
                folding: order.folding,
                // extra: order.extra,
                width: order.width,
                height: order.height,
                foil: order.foil,
                spotUv: order.spotUv,
                totalPrice: order.totalPrice,
                // specialRemark: order.specialRemark,
                cdrFiles_arr: order.cdrFiles_arr,
                createdAt: order.createdAt,
                active: order.active,
                product_objid: order.product_objid
            } as Order;
        });
        this.totalOrders = this.allOrdersFlat.length;
        this.count.emit(this.totalOrders);
        // let ProductGroup = this.allOrdersFlat[0]?.productGroup as any;
        // this.currentProductGroup = this.allOrdersFlat[0]?.productGroup ? this.allOrdersFlat[0]?.productGroup : '';
        this.currentProductGroupCategory = this.allOrdersFlat[0]?.productGroupCategory ? this.allOrdersFlat[0]?.productGroupCategory : '';

        this.filterGstProducts = this.allOrdersFlat.filter((e: any) => e.product_objid?.mpp_IsGstProduct_bl === true);
        this.filterNonGstProducts = this.allOrdersFlat.filter((e: any) => e.product_objid?.mpp_IsGstProduct_bl === false || !e.product_objid?.mpp_IsGstProduct_bl);

        this.tax = 0;
        let taxMap = _.map(this.filterGstProducts, 'product_objid.mpp_productGroup_objid.mpg_tax_objid');
        let textResp = await this.taxesService.query({ find: { _id: { $in: taxMap } } });
        let keyByMap = _.keyBy(textResp, '_id');

        this.tax = keyByMap[this.allOrdersFlat[0]?.product_objid?.mpp_productGroup_objid?.mpg_tax_objid]?.mpt_rate_num;

        for (let item of <any>this.filterGstProducts) {
            if (keyByMap[item.product_objid?.mpp_productGroup_objid?.mpg_tax_objid]) {
                item.totalAmountGSTCharge = (Number(item.totalPrice) * keyByMap[item.product_objid?.mpp_productGroup_objid?.mpg_tax_objid]?.mpt_rate_num) / 100;
            }
        }

        if (this.filterGstProducts && this.filterGstProducts.length) {
            this.totalGstAmount = this.filterGstProducts.reduce((acc: number, order: Order) => {
                return acc + Number(order.totalPrice);
            }, 0);

            // this.shippingWithGst = _.sumBy(this.filterGstProducts, (e: any) => e.product_objid?.mpp_productGroup_objid.mpg_courierChargesWithGst_num);
            // this.transportWithGstCharge = _.sumBy(this.filterGstProducts, (e: any) => e.product_objid?.mpp_productGroup_objid.mpg_transportChargesWithGst_num);
            // this.shippingWithGst = _.sumBy(this.filterGstProducts, (e: any) => e.product_objid?.mpp_productGroup_objid.mpg_courierCharges_num);
            this.shippingWithGst = _.sumBy(this.filterGstProducts, (e: any) => e.product_objid?.mpp_courierCharges_num);
            this.transportWithGstCharge = _.sumBy(this.filterGstProducts, (e: any) => e.product_objid?.mpp_transportCharge_num);
            // this.transportWithGstCharge = _.sumBy(this.filterGstProducts, (e: any) => e.product_objid?.mpp_productGroup_objid.mpg_transportCharges_num);
            this.totalGstCharge = _.sumBy(this.filterGstProducts, (e: any) => e.totalAmountGSTCharge);
        }

        if (this.filterNonGstProducts && this.filterNonGstProducts.length) {
            this.totalOrderAmount = this.filterNonGstProducts.reduce((acc: number, order: Order) => {
                return acc + Number(order.totalPrice);
            }, 0);

            // this.shipping = _.sumBy(this.filterNonGstProducts, (e: any) => e.product_objid?.mpp_productGroup_objid?.mpg_courierCharges_num);
            // this.transportCharge = _.sumBy(this.filterNonGstProducts, (e: any) => e.product_objid?.mpp_productGroup_objid?.mpg_transportCharges_num);

            this.shipping = _.sumBy(this.filterNonGstProducts, (e: any) => e.product_objid?.mpp_courierCharges_num);
            this.transportCharge = _.sumBy(this.filterNonGstProducts, (e: any) => e.product_objid?.mpp_transportCharge_num);
        }


    }

    async getFullAddress() {
        let reqBody = {
            find: { _id: this.authService.gUser?._id },
            select: 'usr_address_str, usr_cityName_str, usr_district_str, usr_state_str, usr_pincode_num',
        };
        let res = await this.userService.amUserQuery(reqBody);
        if (!res || res.length === 0) return { fullAddress: '', cityName: '' };
        let addressObj = res[0];
        let parts = [
            addressObj.usr_address_str,
            addressObj.usr_cityName_str,
            addressObj.usr_state_str,
            addressObj.usr_pincode_num
        ].filter(Boolean); // removes null/undefined/empty
        return {
            fullAddress: parts.join(', '),
            cityName: addressObj.usr_cityName_str
        };
    }

    async changeQuantity(order: Order) {
        try {
            let resp = await this.addOrderService.put(order._id, {
                quantity: order.quantity,
                totalPrice: this.subTotalProduct(order),
            }, { select: '_id' });
            if (resp && resp._id) {
                this.ns.showSuccess('Quantity updated successfully.');
                await this.getOrders();
            }
        } catch (e: any) {
            this.ns.showErrorFromResponse(e.error || e, 'Unable to update data.');
        }
    }

    async halfBladeClick(order: Order) {
        try {
            let body = {
                halfBlade: order.halfBlade,
                totalPrice: this.subTotalProduct(order),
            };
            let resp = await this.addOrderService.put(order._id, body, { select: '_id' });
            if (resp && resp._id) {
                this.ns.showSuccess('Half Blade updated successfully.');
                await this.getOrders();
            }
        } catch (e: any) {
            this.ns.showErrorFromResponse(e.error || e, 'Unable to update data.');
        }
    }

    async creassingClick(order: Order) {
        try {
            let body = {
                crizzing: order.crizzing,
                totalPrice: this.subTotalProduct(order),
            };
            let resp = await this.addOrderService.put(order._id, body, { select: '_id' });
            if (resp && resp._id) {
                this.ns.showSuccess('Crizzing updated successfully.');
                await this.getOrders();
            }
        } catch (e: any) {
            this.ns.showErrorFromResponse(e.error || e, 'Unable to update data.');
        }
    }

    async perforateClick(order: Order) {
        try {
            let body = {
                perforate: order.perforate,
                totalPrice: this.subTotalProduct(order),
            };
            let resp = await this.addOrderService.put(order._id, body, { select: '_id' });
            if (resp && resp._id) {
                this.ns.showSuccess('Perforated updated successfully.');
                await this.getOrders();
            }
        } catch (e: any) {
            this.ns.showErrorFromResponse(e.error || e, 'Unable to update data.');
        }
    }

    async dieClick(order: Order) {
        try {
            let body = {
                dieCharge: order.dieCharge,
                totalPrice: this.subTotalProduct(order),
            };
            let resp = await this.addOrderService.put(order._id, body, { select: '_id' });
            if (resp && resp._id) {
                this.ns.showSuccess('Die updated successfully.');
                await this.getOrders();
            }
        } catch (e: any) {
            this.ns.showErrorFromResponse(e.error || e, 'Unable to update data.');
        }
    }

    async punchingClick(order: Order) {
        try {
            let body = {
                punchingCharge: order.punchingCharge,
                totalPrice: this.subTotalProduct(order),
            };
            let resp = await this.addOrderService.put(order._id, body, { select: '_id' });
            if (resp && resp._id) {
                this.ns.showSuccess('Punching updated successfully.');
                await this.getOrders();
            }
        } catch (e: any) {
            this.ns.showErrorFromResponse(e.error || e, 'Unable to update data.');
        }
    }

    async foldingClick(order: Order) {
        try {
            let body = {
                folding: order.folding,
                totalPrice: this.subTotalProduct(order),
            };
            let resp = await this.addOrderService.put(order._id, body, { select: '_id' });
            if (resp && resp._id) {
                this.ns.showSuccess('Folding updated successfully.');
                await this.getOrders();
            }
        } catch (e: any) {
            this.ns.showErrorFromResponse(e.error || e, 'Unable to update data.');
        }
    }

    async deleteOrder(order: Order) {
        try {
            let res = await this.addOrderService.permanentDelete(order._id);
            if (res) {
                this.allOrdersFlat = this.allOrdersFlat.filter((o: Order) => o._id !== order._id);
                this.totalOrders = this.allOrdersFlat.length;
                this.count.emit(this.totalOrders);
                this.eventCenterS.loadAddToCard.next(true);
                await this.getOrders();
                // this.totalOrderAmount = this.allOrdersFlat.reduce(
                //     (acc: number, o: Order) => acc + Number(o.totalPrice),
                //     0
                // );
                this.ns.showSuccess('Item removed successfully.');
            }
        } catch (e: any) {
            this.ns.showErrorFromResponse(e.error || e, 'Unable to remove order');
        }
    }

    async onSubmit() {
        this.loading = true;
        if (!this.checkoutForm.get('selectedDelivery')?.value) {
            this.loading = false;
            return this.ns.showError('Please Select Delivery Type.');
        }
        if (!this.uploadedFiles.length) {
            this.loading = false;
            return this.ns.showError('Please Upload File.');
        }
        if (this.checkoutForm.valid) {
            let cdrFileUploadres = await this.fileUpload(this.uploadedFiles);

            let saveData = {
                mpr_companyName_objid: this.authService.gUser?._id,
                // mpr_orderNumber_str: Math.random().toString(36).slice(2, 6) + Math.floor(1000 + Math.random() * 9000),
                mpr_billDate_dt: new Date(),
                mpr_cityName_str: this.authService.gUser.usr_cityName_str,
                mpr_deliveryMode_str: this.checkoutForm.get("selectedDelivery")?.value,
                mpr_user_objid: this.authService.gUser?._id,
                mpr_itemDetails_arr: this.allOrdersFlat.map((order: Order) => ({
                    productName: order.productName,
                    products_objid: order?.product_objid?._id,
                    productGroupCategory: order.productGroupCategory,
                    productGroup: order.productGroup,
                    productsGroup_objid: order.productsGroup_objid,
                    // productGroupName: order.productGroupName,
                    user_objid: this.authService.gUser?._id,
                    printing_side: order.printing_side,
                    price: order.price,
                    jobName: order.jobName,
                    quantity: order.quantity,
                    halfBlade: order.halfBlade,
                    crizzing: order.crizzing,
                    perforate: order.perforate,
                    dieCharge: order.dieCharge,
                    punchingCharge: order.punchingCharge,
                    folding: order.folding,
                    // extra: order.extra,
                    height: order.height,
                    width: order.width,
                    squareAndRegular: order.squareAndRegular,
                    foil: order.foil,
                    spotUv: order.spotUv,
                    totalPrice: order.totalPrice,
                    // specialRemark: order.specialRemark,
                    // cdrFiles_arr: order.cdrFiles_arr || [],
                    cdrFiles_arr: cdrFileUploadres || [],
                    createdAt: new Date(),
                    active: true,
                    hsnCode: order.product_objid?.mpp_productGroup_objid?.mpg_hsnCode_num || null,
                    halfBladeCost: Number(this.halfBladeProductCharge(this.allOrdersFlat).toFixed(2)),
                    crizzingCost: Number(this.creassingProductCharge(this.allOrdersFlat).toFixed(2)),
                    perforateCost: Number(this.perforateProductCharge(this.allOrdersFlat).toFixed(2)),
                    dieCost: Number(this.dieProductCharge(this.allOrdersFlat).toFixed(2)),
                    punchingCost: Number(this.punchingProductCharge(this.allOrdersFlat).toFixed(2)),
                    foldingCost: Number(this.foldingProductCharge(this.allOrdersFlat).toFixed(2)),
                })),
                mpr_totalAmount: Number(this.total().toFixed(2)),
                mpr_subTotalAmount: Number(this.subtotal.toFixed(2)),
                mpr_gstTotal: Number(this.gstTotal.toFixed(2)),
                mpr_transportCharges: 0,
                mpr_courierCharges: 0,
                mpr_address: this.checkoutForm.get("text")?.value || this.checkoutForm.get("defaultAddress")?.value,
                mpr_parcel_nos: this.checkoutForm.get("parcelNumber")?.value,
                mpr_order_status: EOrderStatus.IN_PROGRESS,
                mpr_dispatch_bl: false,
                mpr_dispatchDate_dt: "",
                mpr_docketNumber_str: "",
                mpr_special_remark_str: this.checkoutForm.get("message")?.value || ''
            };

            if (this.selectedDeliveryType === 'Courier') {
                saveData.mpr_courierCharges = Number(this.courierCharges.toFixed(2));
                saveData.mpr_transportCharges = 0;
            }
            if (this.selectedDeliveryType === 'Transport') {
                saveData.mpr_transportCharges = Number(this.transportCharges.toFixed(2));
                saveData.mpr_courierCharges = 0;
            }
            if (this.selectedDeliveryType === 'Collect_From_Office') {
                saveData.mpr_courierCharges = 0;
                saveData.mpr_transportCharges = 0;
            }

            try {
                const res = await this.orderCheckoutService.orderPlaceEmailOrNotification(saveData);
                if (res) {
                    this.allOrdersFlat = [];
                    this.totalOrders = 0;
                    this.count.emit(this.totalOrders);
                    this.ns.showInfo("Order successfully placed");
                    this.eventCenterS.loadAddToCard.next(true);
                    this.checkoutForm.get("message")?.setValue(null);
                    this.userService.gUser.next({ action: 'REFRESH_G_USER' });
                    this.loading = false;
                    setTimeout(async () => {
                        await this.router.navigate([ '/myaccount' ]);
                    }, 1000);
                }
            } catch (e: any) {
                this.loading = false;
                this.ns.showErrorFromResponse(e.error || e, 'Something went wrong');
            }
        } else {
            this.loading = false;
            this.ns.showError("Please fill all required details");
        }
    }

    onDeliveryChange(value: any) {
        this.selectedDeliveryType = this.checkoutForm.get('selectedDelivery')?.value;
        if (this.selectedDeliveryType === 'Transport') this.checkoutForm.get('parcelNumber')?.setValue(1);
    }

    get subtotal() {
        this.totalOrderAmount = this.filterNonGstProducts.reduce((acc: number, order: Order) => {
            return acc + Number(order.totalPrice);
        }, 0);

        this.totalGstAmount = this.filterGstProducts.reduce((acc: number, order: Order) => {
            return acc + Number(order.totalPrice);
        }, 0);

        return this.totalOrderAmount + this.totalGstAmount;
    }

    private calculateCharge(orders: Order[] = [], qtyKey: keyof Order, priceKey: keyof NonNullable<Order['product_objid']>): number {
        const total = orders.reduce((sum, item) => {
            const qty = Number(item?.[qtyKey]);
            if (!qty) return sum;

            const price = Number(item?.product_objid?.[priceKey]) || 0;
            return sum + qty * price;
        }, 0);

        return Number(total.toFixed(2));
    }

    halfBladeProductCharge(orders: Order[]): number {
        return this.calculateCharge(orders, 'halfBlade', 'mpp_halfBladePerPrice_num');
    }

    creassingProductCharge(orders: Order[]): number {
        return this.calculateCharge(orders, 'crizzing', 'mpp_creassingPerPrice_num');
    }

    perforateProductCharge(orders: Order[]): number {
        return this.calculateCharge(orders, 'perforate', 'mpp_perforatedPerPrice_num');
    }

    dieProductCharge(orders: Order[]): number {
        return this.calculateCharge(orders, 'dieCharge', 'mpp_diePerPrice_num');
    }

    punchingProductCharge(orders: Order[]): number {
        return this.calculateCharge(orders, 'punchingCharge', 'mpp_punchingPerPrice_num');
    }

    foldingProductCharge(orders: Order[]): number {
        return this.calculateCharge(orders, 'folding', 'mpp_foldingPerPrice_num');
    }

    subTotalWithCharge(): number {
        const orders = this.allOrdersFlat ?? [];

        // const totalCharges =
        //     this.halfBladeProductCharge(orders) +
        //     this.creassingProductCharge(orders) +
        //     this.perforateProductCharge(orders) +
        //     this.dieProductCharge(orders) +
        //     this.punchingProductCharge(orders) +
        //     this.foldingProductCharge(orders);

        return Number((this.subtotal).toFixed(2));
    }

    total(): number {
        let shippingCharge = 0;
        const orders = this.allOrdersFlat ?? [];

        switch (this.selectedDeliveryType) {
            case 'Courier':
                shippingCharge = this.courierCharges;
                break;
            case 'Transport':
                shippingCharge = this.transportCharges;
                break;
            case 'Collect_From_Office':
            default:
                shippingCharge = 0;
        }
        const totalCharges = this.halfBladeProductCharge(orders) + this.creassingProductCharge(orders) + this.perforateProductCharge(orders) +
            this.dieProductCharge(orders) + this.punchingProductCharge(orders) + this.foldingProductCharge(orders);

        return Number((this.subtotal + this.gstTotal + shippingCharge + totalCharges).toFixed(2));
    }

    subTotalProduct(order: Order): number {
        if (!order?.price || !order?.quantity) return 0;

        const pricePerUnit = Number(order.price);
        const quantity = Number(order.quantity) / 1000;
        let total = order.productGroupCategory === EProductGroupType.SPECIAL_JOB ? pricePerUnit : pricePerUnit * quantity;

        // total += this.calculateCharge([ order ], 'halfBlade', 'mpp_halfBladePerPrice_num');
        // total += this.calculateCharge([ order ], 'crizzing', 'mpp_creassingPerPrice_num');
        // total += this.calculateCharge([ order ], 'perforate', 'mpp_perforatedPerPrice_num');
        // total += this.calculateCharge([ order ], 'dieCharge', 'mpp_diePerPrice_num');
        // total += this.calculateCharge([ order ], 'punchingCharge', 'mpp_punchingPerPrice_num');
        // total += this.calculateCharge([ order ], 'folding', 'mpp_foldingPerPrice_num');

        // Sticker / GSM logic
        if (order.productGroupCategory === EProductGroupType.STICKER_PER_SQ_INCH || order.productGroupCategory === EProductGroupType.GSM_ART_MIX_250) {
            total = pricePerUnit * quantity * Number(order.width || 1) * Number(order.height || 1);
        }

        if (order.productGroupCategory === EProductGroupType.VISITING_CARD || order.productGroupCategory === EProductGroupType.PREMIUM_VISITING_CARD) {
            const foil = order.foil;
            // console.log(foil);
            const spotUv = order.spotUv;
            // console.log(spotUv);
            // console.log(this.currentProductOrdered);
            if (spotUv) {
                if (spotUv === 'Single Side') total += Number(this.currentProductOrdered.mpp_spot_uv_single_price_num) * quantity;
                if (spotUv === 'Both Side') total += Number(this.currentProductOrdered.mpp_spot_uv_both_price_num) * quantity;
            }
            if (foil) {
                if (foil === 'Gold') total += Number(this.currentProductOrdered.mpp_foil_golden_price_num) * quantity;
                if (foil === 'Silver') total += Number(this.currentProductOrdered.mpp_foil_silver_price_num) * quantity;
            }
        }

        return Number(total.toFixed(2));
    }

    // get subTotalWithCharge() {
    //     // if (this.currentProductGroupCategory === EProductGroupType.SPECIAL_JOB) {
    //     const halfBlade = this.halfBladeProductCharge(this.allOrdersFlat) || 0;
    //     const creassing = this.creassingProductCharge(this.allOrdersFlat) || 0;
    //     const perforate = this.perforateProductCharge(this.allOrdersFlat) || 0;
    //     const die = this.dieProductCharge(this.allOrdersFlat) || 0;
    //     const punching = this.punchingProductCharge(this.allOrdersFlat) || 0;
    //     const folding = this.foldingProductCharge(this.allOrdersFlat) || 0;
    //
    //     return Number((this.subtotal - halfBlade - creassing - perforate - die - punching - folding).toFixed(2));
    //     // } else {
    //     //     return this.subtotal || 0;
    //     // }
    // }
    //
    // get total() {
    //     let shippingCharge = 0;
    //     if (this.selectedDeliveryType === 'Courier') shippingCharge = this.courierCharges;
    //     if (this.selectedDeliveryType === 'Transport') shippingCharge = this.transportCharges;
    //     if (this.selectedDeliveryType === 'Collect_From_Office') shippingCharge = 0;
    //     //
    //     // const halfBlade = this.halfBladeProductCharge(this.allOrdersFlat) || 0;
    //     // const creassing = this.creassingProductCharge(this.allOrdersFlat) || 0;
    //     // const perforate = this.perforateProductCharge(this.allOrdersFlat) || 0;
    //     // const die = this.dieProductCharge(this.allOrdersFlat) || 0;
    //     // const punching = this.punchingProductCharge(this.allOrdersFlat) || 0;
    //     // const folding = this.foldingProductCharge(this.allOrdersFlat) || 0;
    //     //
    //     // let chargeOther = Number(halfBlade + creassing + perforate + die + punching + folding);
    //     // if (this.currentProductGroupCategory === EProductGroupType.SPECIAL_JOB) return this.subtotal + this.gstTotal + shippingCharge;
    //     return this.subtotal + this.gstTotal + shippingCharge;
    // }
    //
    //
    // get subTotalProduct() {
    //     return (order: Order) => {
    //         if (!order || !order.price || !order.quantity) return 0;
    //         let pricePerUnit = Number(order.price);
    //         const quantity = Number(order.quantity) / 1000;
    //         let total = 0;
    //         if (order.productGroupCategory === EProductGroupType.SPECIAL_JOB) total = pricePerUnit;
    //         else total = pricePerUnit * quantity;
    //
    //         if (order.halfBlade) {
    //             const halfBladePrice = (order.product_objid?.mpp_halfBladePerPrice_num) * Number(order.halfBlade);
    //             total += halfBladePrice;
    //         }
    //
    //         if (order.crizzing) {
    //             const crizzingPrice = (order.product_objid?.mpp_creassingPerPrice_num) * Number(order.crizzing);
    //             total += crizzingPrice;
    //         }
    //
    //         if (order.perforate) {
    //             const perforatePrice = (order.product_objid?.mpp_perforatedPerPrice_num) * Number(order.perforate);
    //             total += perforatePrice;
    //         }
    //
    //         if (order.dieCharge) {
    //             const diePrice = (order.product_objid?.mpp_diePerPrice_num) * Number(order.dieCharge);
    //             total += diePrice;
    //         }
    //
    //         if (order.punchingCharge) {
    //             const punchingCharge = (order.product_objid?.mpp_punchingPerPrice_num) * Number(order.punchingCharge);
    //             total += punchingCharge;
    //         }
    //
    //
    //         // if (order.dieCharge) {
    //         //     // const diePrice =
    //         //     //     (order.product_objid?.mpp_diePerPrice_num / 1000) *
    //         //     //     quantity *
    //         //     //     Number(order.dieCharge);
    //         //     // total += order.product_objid?.mpp_diePerPrice_num;
    //         //     total += Number(order.dieCharge) === 0 ? 0 : order.product_objid?.mpp_diePerPrice_num;
    //         // }
    //         // if (order.punchingCharge) {
    //         //     // const diePrice =
    //         //     //     (order.product_objid?.mpp_punchingPerPrice_num / 1000) *
    //         //     //     quantity *
    //         //     //     Number(order.punchingCharge);
    //         //
    //         //     total += Number(order.punchingCharge) === 0 ? 0 : order.product_objid?.mpp_punchingPerPrice_num;
    //         //     // total += diePrice;
    //         // }
    //
    //         if (order.folding) {
    //             const foldingPrice = (order.product_objid?.mpp_foldingPerPrice_num) * Number(order.folding);
    //             total += foldingPrice;
    //         }
    //
    //         // Sticker / GSM logic
    //         if (
    //             order.productGroupCategory === EProductGroupType.STICKER_PER_SQ_INCH ||
    //             order.productGroupCategory === EProductGroupType.GSM_ART_MIX_250
    //         ) {
    //             total = (Number(pricePerUnit) * quantity) * (Number(order.width) * Number(order.height));
    //         }
    //         // console.log('Final total ', total);
    //         return Number(total.toFixed(2)); // Rounded to 2 decimals
    //     };
    // };
    //
    // get halfBladeProductCharge() {
    //     return (orders: Order[]) => {
    //         if (!orders || !orders.length) return 0;
    //
    //         let totalHalfBladePrice = 0;
    //
    //         for (const item of orders) {
    //             if (!item || !item.quantity) continue;
    //             const halfBladePricePerUnit = Number(item.product_objid?.mpp_halfBladePerPrice_num || 0);
    //
    //             if (item.halfBlade) {
    //                 const halfBladePrice = halfBladePricePerUnit * Number(item.halfBlade);
    //                 totalHalfBladePrice += halfBladePrice;
    //             }
    //         }
    //         return Number(totalHalfBladePrice.toFixed(2)); // total for all products
    //     };
    // };
    //
    // get creassingProductCharge() {
    //     return (orders: Order[]) => {
    //         if (!orders || !orders.length) return 0;
    //
    //         let totalCrizzingPrice = 0;
    //
    //         for (const item of orders) {
    //             if (!item || !item.quantity) continue;
    //             const crizzingPricePerUnit =
    //                 Number(item.product_objid?.mpp_creassingPerPrice_num || 0);
    //
    //             if (item.crizzing) {
    //                 const crizzingPrice = crizzingPricePerUnit * Number(item.crizzing);
    //                 totalCrizzingPrice += crizzingPrice;
    //             }
    //         }
    //         return Number(totalCrizzingPrice.toFixed(2)); // total for all products
    //     };
    // };
    //
    // get perforateProductCharge() {
    //     return (orders: Order[]) => {
    //         if (!orders || !orders.length) return 0;
    //
    //         let totalPerforatePrice = 0;
    //
    //         for (const item of orders) {
    //             if (!item || !item.quantity) continue;
    //
    //             const perforatePricePerUnit =
    //                 Number(item.product_objid?.mpp_perforatedPerPrice_num || 0);
    //
    //             if (item.perforate) {
    //                 const perforatePrice = perforatePricePerUnit * Number(item.perforate);
    //                 totalPerforatePrice += perforatePrice;
    //             }
    //         }
    //         return Number(totalPerforatePrice.toFixed(2)); // total for all products
    //     };
    // };
    //
    // get dieProductCharge() {
    //     return (orders: Order[]) => {
    //         if (!orders || !orders.length) return 0;
    //
    //         let totalDiePrice = 0;
    //
    //         for (const item of orders) {
    //             if (!item || !item.quantity) continue;
    //
    //             const diePricePerUnit =
    //                 Number(item.product_objid?.mpp_diePerPrice_num || 0);
    //
    //             if (item.dieCharge) {
    //                 const diePrice = diePricePerUnit * Number(item.dieCharge);
    //                 totalDiePrice += diePrice;
    //             }
    //         }
    //         return Number(totalDiePrice.toFixed(2)); // total for all products
    //
    //         //
    //         // for (const item of orders) {
    //         //     if (!item || !item.quantity) continue;
    //         //
    //         //     // const quantity = Number(item.quantity);
    //         //     // const diePricePerUnit =
    //         //     //     Number(item.product_objid?.mpp_diePerPrice_num || 0) / 1000;
    //         //
    //         //     if (item.dieCharge) {
    //         //         // const diePrice = diePricePerUnit * quantity * Number(item.dieCharge);
    //         //         // totalDiePrice += diePrice;
    //         //         totalDiePrice += Number(item.dieCharge) === 0 ? 0 : item.product_objid?.mpp_diePerPrice_num;
    //         //     }
    //         // }
    //         // return Number(totalDiePrice.toFixed(2)); // total for all products
    //     };
    // };
    //
    // get punchingProductCharge() {
    //     return (orders: Order[]) => {
    //         if (!orders || !orders.length) return 0;
    //
    //         let totalPunchingPrice = 0;
    //
    //         for (const item of orders) {
    //             if (!item || !item.quantity) continue;
    //
    //             const punchingPricePerUnit =
    //                 Number(item.product_objid?.mpp_punchingPerPrice_num || 0);
    //
    //             if (item.punchingCharge) {
    //                 const punchingPrice = punchingPricePerUnit * Number(item.punchingCharge);
    //                 totalPunchingPrice += punchingPrice;
    //             }
    //         }
    //         return Number(totalPunchingPrice.toFixed(2)); // total for all products
    //
    //         // for (const item of orders) {
    //         //     if (!item || !item.quantity) continue;
    //         //
    //         //     // const quantity = Number(item.quantity);
    //         //     // const punchingPricePerUnit =
    //         //     //     Number(item.product_objid?.mpp_punchingPerPrice_num || 0) / 1000;
    //         //
    //         //     if (item.punchingCharge) {
    //         //         // const punchingPrice = punchingPricePerUnit * quantity * Number(item.punchingCharge);
    //         //         totalPunchingPrice += Number(item.punchingCharge) === 0 ? 0 : item.product_objid?.mpp_punchingPerPrice_num;
    //         //         // const punchingPrice = punchingPricePerUnit * quantity * Number(item.punchingCharge);
    //         //         // totalPunchingPrice += punchingPrice;
    //         //     }
    //         // }
    //         // return Number(totalPunchingPrice.toFixed(2)); // total for all products
    //     };
    // };
    //
    // get foldingProductCharge() {
    //     return (orders: Order[]) => {
    //         if (!orders || !orders.length) return 0;
    //
    //         let totalFoldingPrice = 0;
    //
    //         for (const item of orders) {
    //             if (!item || !item.quantity) continue;
    //
    //             const quantity = Number(item.quantity);
    //             const foldingPricePerUnit =
    //                 Number(item.product_objid?.mpp_foldingPerPrice_num || 0);
    //
    //             if (item.folding) {
    //                 const foldingPrice = foldingPricePerUnit * Number(item.folding);
    //                 totalFoldingPrice += foldingPrice;
    //             }
    //         }
    //         return Number(totalFoldingPrice.toFixed(2)); // total for all products
    //     };
    // };

    get courierCharges() {
        if (this.currentProductGroupCategory === EProductGroupType.SPECIAL_JOB) {
            return (this.shipping || 0) + (this.shippingWithGst || 0);
        }
        if (this.selectedDeliveryType === 'Courier') {
            return ((this.shipping || 0) + (this.shippingWithGst || 0)) * (Number(this.allOrdersFlat[0]?.quantity) / 1000);
        } else return 0;
    }

    get transportCharges() {
        if (this.currentProductGroupCategory === EProductGroupType.SPECIAL_JOB) {
            return (this.transportCharge + this.transportWithGstCharge) * this.checkoutForm.get("parcelNumber")?.value;
        }
        if (this.selectedDeliveryType === 'Transport') {
            return (this.transportCharge + this.transportWithGstCharge) * this.checkoutForm.get("parcelNumber")?.value;
        } else return 0;
    }

    get gstTotal() {
        let shippingCharge = 0;
        if (this.selectedDeliveryType === 'Courier') shippingCharge = this.courierCharges * this.tax / 100;
        if (this.selectedDeliveryType === 'Transport') shippingCharge = this.transportCharges * this.tax / 100;
        if (this.selectedDeliveryType === 'Collect_From_Office') shippingCharge = 0;
        return Number(this.totalGstCharge + shippingCharge) || 0;
    }

    onParcelInput(event: any) {
        if (event.target.value < 0) {
            event.target.value = 0;
            this.checkoutForm.get('parcelNumber')?.setValue(0);
        }
    }

    removeFile($event: any) {
        this.uploadedFiles = this.uploadedFiles.filter(file => file != $event.file);
    }

    clearFiles() {
        this.uploadedFiles = [];
    }
}

interface qty {
    name: string;
    code: string;
}

interface deliver {
    name: string;
    code: string;
}

interface Order {
    _id: string;
    productName: string;
    product_objid: any;
    productGroup: string;
    printing_side: string;
    productGroupName?: string;
    productGroupCategory?: string;
    productsGroup_objid?: string;
    user_objid: string;
    price: string | number;
    jobName: string;
    quantity: string | number;
    halfBlade: string | number;
    crizzing: string | number;
    perforate: string | number;
    dieCharge: string | number;
    punchingCharge: string | number;
    folding: string | number;

    halfBladeCost?: number;
    crizzingCost?: number;
    perforateCost?: number;
    dieCost?: number;
    punchingCost?: number;
    foldingCost?: number;

    extra: string | number;
    width: string | number;
    height: string | number;
    foil: string | number;
    spotUv: string | number;
    totalPrice: string | number;
    squareAndRegular?: string;
    specialRemark?: string;
    cdrFiles_arr?: any[];
    createdAt?: string | Date;
    active: boolean;
}
